import Modal from 'portaltransparencia-common/components/Modal.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

import GastoPecaTable from './GastoPecaTable.react';

export class GastoPecaModal extends Component {
  static propTypes = {
    gastosPeca: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  render() {
    const { gastosPeca, show, onClose } = this.props;

    if (show) {
      return (
        <Modal onClose={onClose}>
          <GastoPecaTable gastosPeca={gastosPeca} />
        </Modal>
      );
    }

    return null;
  }
}

export default GastoPecaModal;
